module.exports = __webpack_public_path__ + "img/image29.d70aa987.jpg";